exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".selected-train {\n  background-color: yellow !important;\n}", ""]);

